import { render, staticRenderFns } from "./DayNewsFeedItem.vue?vue&type=template&id=7f38d0ce&"
import script from "./DayNewsFeedItem.vue?vue&type=script&lang=js&"
export * from "./DayNewsFeedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports